module.exports = __webpack_public_path__ + "img/sort.4b5a3098.svg";